module.exports = __webpack_public_path__ + "eb769312.svg";